import { render, staticRenderFns } from "./outbrain-marketers-app.vue?vue&type=template&id=0fa83e88"
import script from "./outbrain-marketers-app.vue?vue&type=script&lang=js"
export * from "./outbrain-marketers-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports